// Module
var code = `<div appHeaderBar><header-bar-title>Edit Payment</header-bar-title></div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <form *ngIf="doneLoading" name="PaymentDateEdit" id="PaymentDateEdit" tid="PaymentDateEdit" #paymentDateEdit="ngForm">
        <div class="HOA-container">
            <div class="HOA-container__header">
                <div class="HOA-container__header-text hide-if-platform-size-phone"
                     tid="headerDateWeb">
                    Edit Payment - {{futurePayment.date.formattedFullDate}}
                </div>
                <div class="HOA-container__header-text hide-if-platform-web"
                     tid="headerDateMobile">
                    Payment - {{futurePayment.date.formattedFullDate}}
                </div>
            </div>
            <div class="HOA-container__content">
                <div class="HOA-flex-component
                                    HOA-misc-guidedSteps__flex-space-between
                                    HOA-misc-guidedSteps__flex-padded
                                    HOA-font-table-header
                                    u-pB4">
                            <span>
                                <span *ngIf="dues.length > 1">
                                    Select items to pay
                                </span>
                            </span>
                    <span class="HOA-make-payment-amount-to-pay">Enter Payment Amount</span>
                </div>
                <div class="HOA-misc-guidedSteps__flex-padded">
                    <div class="HOA-flex-component HOA-make-payment-item-row--top-justified"
                         *ngFor="let due of dues; index as \$index">

                        <div *ngIf="dues.length > 1"
                             class="HOA-flex-component
                                            HOA-make-payment-flex-align
                                            HOA-make-payment-fancy-width u-pT2">
                            <!-- many rows in dues -->
                            <input type="checkbox"
                                   id="hoa-item-input-{{\$index}}"
                                   [name]="'hoa-item-input-' + \$index"
                                   tid="hoa-item-input-{{\$index}}"
                                   class="Field u-cf"
                                   style="margin-bottom: 26px; accent-color: #00505c"
                                   [(ngModel)]="due.toPay"
                                   [ngClass]="{'is-invalid': false}"
                                   (change)="updateAmount()">
                            <label for="hoa-item-input-{{\$index}}" class="HOA-font-light">
                                <div>{{due.name}}</div>
                                <div>
                                        <span class="HOA-make-payment-item-row-details-due-date u-mT2">
                                            <span class="u-app-hide-if-size-is-phone">Due: </span>
                                            <span>{{due.dueDate}}</span>
                                        </span>
                                </div>
                            </label>
                            <span tid="hoa-item-input-{{\$index}}-error" class="Field-error">
                                        Please agree to the above terms.
                                    </span>
                        </div>

                        <div *ngIf="dues.length === 1"
                             class="HOA-flex-component
                                            HOA-make-payment-flex-align
                                            HOA-make-payment-fancy-width u-pT3">
                            <!-- single row in dues -->
                            <div class="HOA-make-payment-flex HOA-make-payment-item-row-details">
                                <label tid="amountSingleDueLabel">
                                    Amount
                                    <span class="asterisk-required">&nbsp;&#42;</span>
                                </label>
                            </div>
                        </div>
                        <div [ngClass]="{ 'is-invalid': isDueAmountInvalid(due) }"
                             class="Field u-cf HOA-make-payment-item-row-amount">
                            <div  class="Field-addonBox ">
                                <input id="amount1"
                                       name="amount1"
                                       tid="amountSingleDue"
                                       type="text"
                                       class="Input"
                                       [(ngModel)]="due.amount"
                                       (focus)="removeAccountBalanceTbd();clearAmountFieldWhen0(due)"
                                       (change)="updateAmount()"
                                       aria-invalid="isDueAmountInvalid(due)"
                                       attr.aria-describedby="{{ isDueAmountInvalid(due) && 'amount1-error' || undefined }}"
                                       maxlength="9"
                                       placeholder="{{accountBalanceTbd && 'Amount Due' || ''}}"
                                       blank-when-zero
                                       custom-currency>
                                <button *ngIf="!accountBalanceTbd"
                                        tid="amountSingleClearButton"
                                        type="button"
                                        class="Field-addon"
                                        (click)="clearDue(due)"
                                        aria-label="Click to clear payment amount">
                                    x
                                </button>
                            </div>
                            <span id="amount1-error"
                                  tid="amountSingleError"
                                  class="Field-error">
                                        {{amountToPayErrorMsg ? amountToPayErrorMsg : "Please enter an amount."}}
                                    </span>
                        </div>
                    </div>

                    <!--Administrative Fee-->
                    <div class="HOA-flex-component HOA-make-payment-item-row" >
                        <div class="HOA-flex-component
                                            HOA-misc-guidedSteps__flex-align
                                            HOA-make-payment-fancy-width">
                            <div class="HOA-misc-guidedSteps__flex HOA-make-payment-item-row-amount-details"
                                 tid="convenienceFeeLabel">
                                Administrative Fee
                            </div>
                        </div>
                        <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                                    <span tid="convenienceFeeAmount" >
                                        {{accountBalanceTbd ? 'Calculated' : (convenienceFee | currency)}}
                                    </span>
                        </div>
                    </div>
                    <!--Convenience fee-->
                    <div class="HOA-flex-component HOA-make-payment-item-row" >
                        <div class="HOA-flex-component
                                            HOA-misc-guidedSteps__flex-align
                                            HOA-make-payment-fancy-width">
                            <div class="HOA-misc-guidedSteps__flex HOA-make-payment-item-row-amount-details"
                                 tid="amountToBePaidLabel">
                                Amount to be paid
                            </div>
                        </div>
                        <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                                    <span tid="amountToBePaid"
                                          class="HOA-make-payment-amount-owed">
                                        {{amountToPayErrorMsg ? 'n/a' : (totalAmount | currency) || 'n/a' }}
                                    </span>
                        </div>
                    </div>
                    <!--Error messages-->
                    <!--<div class="HOA-flex-component HOA-make-payment-item-row" *ngIf="amountToPayErrorMsg">-->
                    <!--<div class="HOA-flex-component HOA-misc-guidedSteps__flex-align HOA-make-payment-fancy-width">-->
                    <!--&lt;!&ndash;place holder&ndash;&gt;-->
                    <!--</div>-->
                    <!--<div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">-->
                    <!--<span class="" tid="amountToPayErrorMsg" ng-bind="amountToPayErrorMsg"></span>-->
                    <!--</div>-->
                    <!--</div>-->

                    <div class="HOA-misc-guidedSteps__flex u-mT4">
                        <div [ngClass]="{ 'is-invalid': paymentMethodError }"
                             class="Field HOA-misc-guidedSteps__flex-child HOA-make-payment-w100">
                            <label class="Field-label" for="paymentMethodNow" tid="paymentMethodNowLabel">
                                Payment Method
                                <!--<a class="u-floatRight" routerLink="/wallet">Add</a>-->
                            </label>
                            <div class="Select">
                                <select id="paymentMethodNow"
                                        tid="paymentMethodNow"
                                        name="paymentMethodNow"
                                        aria-invalid="paymentMethodError"
                                        attr.aria-describedby="{{paymentMethodError && 'paymentMethodNow-error' || undefined }}"
                                        [(ngModel)]="currentPaymentMethod"
                                        (change)="updatePaymentMethod(); updateConvenienceFee()"
                                        [disabled]="true">
                                    <option *ngFor="let paymentMethod of paymentMethods" [ngValue]="paymentMethod">
                                        {{((paymentMethod.nickname) ?
                                        paymentMethod.nickname :
                                        paymentMethod.line1) + ' (' + paymentMethod.maskedId + ')'}}
                                    </option>
                                </select>
                            </div>
                            <span id="paymentMethodNow-error" tid="paymentMethodNow-error" class="Field-error">
                                        {{paymentMethodErrorMsg ? paymentMethodErrorMsg : "Please select a payment method."}}
                                    </span>
                            <span *ngIf="currentPaymentMethod.routingNumber"
                                  tid="paymentMethodNowACHMessage"
                                  class="HOA-Field-detail">
                                        {{ACHMessage}}
                                    </span>
                        </div>
                        <span class="HOA-make-guidedSteps_middleColumn"> </span>
                        <div class="Field HOA-misc-guidedSteps__flex-child">
                            <app-mat-date-picker
                                    [labelText]="'Payment Date'"
                                    [required]="false"
                                    [config]="datePickerConfig"
                                    (onDateChange)="onDateChange(\$event)">
                            </app-mat-date-picker>
                            <span tid="paymentsNowProcessed" class="HOA-Field-detail">
                                        Payments are processed Monday through Friday, excluding holidays.
                                        Payments submitted on weekends or holidays may be delayed.
                                    </span>
                        </div>
                    </div>
                    <div class="u-pB5">
                        <input type="checkbox"
                               *ngIf="paymentScheduleType !== 'account-balance'"
                               id="remainingPaymentsCheckbox"
                               name="remainingPaymentsCheckbox"
                               tid="remainingPaymentsCheckbox"
                               class="Field u-cf"
                               style="accent-color: #00505c; border: 1px solid #bababa"
                               [(ngModel)]="remainingPaymentsCheckbox"
                               [ngClass]="{'is-invalid': false}">
                        <label for="remainingPaymentsCheckbox" class="HOA-font-light">
                            Please check this box if you want to update the payment amount for
                            all future payments in this schedule.
                        </label>
                    </div>
                    <div class="u-pB5">
                        <input type="checkbox"
                               id="tcCheckbox"
                               name="tcCheckbox"
                               tid="tcCheckbox"
                               class="Field u-cf"
                               style="accent-color: #00505c"
                               [(ngModel)]="tcCheckbox"
                               [ngClass]="{'is-invalid': false}"
                               (change)="updateAmount()">
                        <label for="tcCheckbox" class="HOA-font-light">
                            I agree to pay the total amount including any fees as shown above.
                        </label>
                        <span tid="tcCheckbox-error" class="Field-error">Please agree to the above terms.</span>
                    </div>
                    <div class="u-pT2 HOA-flex-component HOA-flextable-component__flex-end">
                        <button name="cancel"
                                id="cancel"
                                tid="cancel"
                                type="button"
                                class="Button Button--link HOA-make-payment-button"
                                [routerLink]="['/properties/scheduleView/', paymentScheduleId]" [state]="{scheduleId: paymentScheduleId}">
                            Cancel
                        </button>
                        <button name="submit"
                                id="submit"
                                tid="submit"
                                type="submit"
                                [disabled]="paymentDateEdit.invalid || submitDisabled()"
                                class="Button Button--blue HOA-make-payment-button"
                                ifOverFlowXClass="Button--overflowX"
                                (click)="checkTerms()">
                            <div [ngClass]="{'u-visibility-hidden': !calculatingConvenienceFee}"
                                 class="HOA-absolutelyCentered">
                                <div class="spinner spinner--small">
                                    <div *ngFor="let i of [1,2,3,4,5,6,7,8,9,0]"></div>
                                </div>
                            </div>
                            <span [ngClass]="{'u-visibility-hidden': calculatingConvenienceFee}">
                                        Continue
                                    </span>
                        </button>
                    </div>
                    <div class="u-pT2 HOA-flex-component HOA-font-fine-print">
                        <span class="asterisk-required">&#42;</span>
                        &nbsp;Indicates required field</div>
                </div>
            </div>
            <!--<div class="HOA-container__content">-->
            <!--<div class="HOA-flextable-component HOA-flextable-component__form">-->
            <!--<div ng-class="{ 'is-invalid': paymentAmtErrMsg }" class="Field HOA-flextable-component__cell-input HOA-CheckingAccount-padding-top-sm12-lg2">-->
            <!--<label tid="paymentAmountLabel" id="paymentAmountLabel" for="paymentAmount" class="Field-label">Payment Amount</label>-->
            <!--<div  class="Field-addonBox">-->
            <!--<input type="text" id="paymentAmount" tid="paymentAmount" class="Input" ng-model="paymentAmount" ng-change="validateTotalAmount()" ng-focus="clearAmountFieldIf0()" aria-invalid="{{paymentAmtErrMsg ? true : false}}" ng-attr-aria-describedby="{{paymentAmtErrMsg && 'paymentAmount-error' || undefined }}" maxlength="8" custom-currency-ajs required />-->
            <!--<button type="button"  class="Field-addon" ng-click="clearPaymentAmount()" aria-label="Click to clear payment amount">&times;</button>-->
            <!--</div>-->
            <!--<span class="Field-error" tid="paymentAmount-error" id="paymentAmount-error">{{paymentAmtErrMsg}}</span>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="HOA-flextable-component HOA-flextable-component__form HOA-Has-Default-Switch">-->
            <!--<div class="Field HOA-flextable-component__cell-input HOA-sm-order-2 HOA-lg-order-1">-->
            <!--<date-picker anonymous="false" id="paymentDatePicker" date="futurePayment.date" date-change="setPaymentDate(date)" label="Payment Date"></date-picker>-->
            <!--</div>-->

            <!--<div class="Field HOA-flextable-component__cell-input HOA-sm-order-1 HOA-lg-order-2">-->
            <!--<label class="Field-label">Current Schedule Payment Date</label>-->
            <!--<div class="u-pH4">-->
            <!--<span tid="address1" ng-bind="existingFuturePayment.date.formattedFullDate"></span>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->

            <!--<div class="HOA-Checking-Detail-button-container">-->
            <!--<button name="cancel" id="cancel" tid="cancel" type="button" class="Button Button&#45;&#45;link " ng-click="cancel()">Cancel</button>-->
            <!--<button name="submitSave" id="submitSave" tid="submitSave" type="submit" class="Button Button&#45;&#45;blue" ng-click="save()">Save</button>-->
            <!--</div>-->
            <!--<div class="u-pT2 HOA-flex-component HOA-font-fine-print"><span class="asterisk-required">&#42;</span>&nbsp;Indicates required field</div>-->
            <!--</div>-->
        </div>
    </form>
</app-page-content>`;
// Exports
module.exports = code;